import { render, staticRenderFns } from "./acces-examens.html?vue&type=template&id=59d6fbf2&scoped=true&external"
import script from "./acces-examens.js?vue&type=script&lang=js&external"
export * from "./acces-examens.js?vue&type=script&lang=js&external"
import style0 from "./acces-examens.scss?vue&type=style&index=0&id=59d6fbf2&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59d6fbf2",
  null
  
)

export default component.exports